module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cn-f5a6f048eb8367343bd42fd1895a8c5f.svg";